import cx from 'classnames';
import type { FunctionComponent } from 'react';

import Icon, { icons } from '../Icon';

import type { AccordionTargetProps } from './useAccordion';

import styles from './Accordion.module.less';

type Props = AccordionTargetProps & {
  isOpen: boolean;
};

/**
 * The click target for the accordion component.
 * Holds any arbitrary content. Includes the arrow down icon.
 */
const Target: FunctionComponent<Props> = ({ children, isOpen, ...props }) => (
  <button {...props}>
    <span className={cx(styles.targetIcon, {
      [styles.targetIconIsOpen]: isOpen,
    })}>
      <Icon icon={icons.angleRight} />
    </span>

    {children}
  </button>
);

Target.displayName = 'AccordionTarget';

export default Target;
